import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import styles from '../../pages/OrganizationIndexPage/styles.css';

class ProgramRenderer extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { value, data } = this.props;
    if (!data) {
      return null;
    }
    const type = data.type_name;

    let l = type;
    if (type === 'Win Loss') {
      l = 'wl';
    } else if (type === 'Customer Experience') {
      l = 'ce';
    } else if (type === 'Voice of the Buyer') {
      l = 'vb';
    } else if (type === 'Market Research') {
      l = 'mr';
    }

    const tip = (
      <Tooltip id={data._id}>
        <div>{type}</div>
      </Tooltip>
    );

    return (
      <div>
        <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={tip}>
          <span key={type} className={`${styles.type} ${styles[l]}`}>
            <span>{l}</span>
          </span>
        </OverlayTrigger>
        {' '}
        {value}
      </div>
    );
  }
}

ProgramRenderer.propTypes = {
  value: PropTypes.number,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    type_name: PropTypes.string.isRequired,
  }),
};
ProgramRenderer.defaultProps = {
  value: null,
  data: null,
};


export default ProgramRenderer;
